import { getDownloadHeadersWithCurrentAccountConsumerId } from 'lib/downloads/utils';
import {
  AdapterSource,
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherEndpoint,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { Dispatch } from 'redux';
import { DFDHeaders } from 'serverTypes/authentication';
import FileServices from 'services/FileServices';
import { RootDispatch, RootState, Thunk } from 'store/types';
import { MhpDetails } from './types';

export const DELETE_DOCUMENT = `MESSAGE.DELETE_DOCUMENT`;
export const DELETE_DOCUMENT_SUCCESS = `MESSAGE.DELETE_DOCUMENT_SUCCESS`;
export const DELETE_DOCUMENT_FAIL = `MESSAGE.DELETE_DOCUMENT_FAIL`;

export const deleteDocument = (messageUUID: string, attachmentUUID: string) => ({
  type: DELETE_DOCUMENT,
  payload: {
    client: 'dispatcher',
    request: {
      method: 'delete',
      headers: {
        [DFDHeaders.contentType]: 'application/x-www-form-urlencoded;charset=UTF-8',
        [DFDHeaders.mhpMessageUuid]: messageUUID,
        [DFDHeaders.resourceId]: attachmentUUID,
        [DFDHeaders.mhpAdapter]: AdapterSource.UTAH
      },
      url: getDispatcherUrl(
        DispatcherCategoryService.HEALTH_RECORDS,
        DispatcherAuthPrefix.AUTHENTICATED,
        DispatcherResource.ATTACHMENTS,
        DispatcherEndpoint.ID
      )
    }
  }
});

export const GET_MESSAGE_BY_ID = 'MESSAGING.GET_MESSAGE_BY_ID';
export const GET_MESSAGE_BY_ID_SUCCESS = 'MESSAGING.GET_MESSAGE_BY_ID_SUCCESS';
export const GET_MESSAGE_BY_ID_FAIL = 'MESSAGING.GET_MESSAGE_BY_ID_FAIL';
export const RESET_MESSAGE_DETAIL = 'MESSAGING.RESET_MESSAGE_DETAIL';
export const getMessageById = (mhpDetails: MhpDetails) => ({
  type: GET_MESSAGE_BY_ID,
  payload: {
    client: 'dispatcher',
    request: {
      method: 'get',
      url: mhpDetails.url || DispatcherEndpoint.FAIL,
      headers: {
        ...mhpDetails.headers
      }
    }
  }
});

export const resetMessageDetail = (): Thunk => (dispatch: RootDispatch) => {
  return dispatch({ type: RESET_MESSAGE_DETAIL });
};

export const MESSAGE_COMPOSE_CLEAR_PROVIDER_SELECTED =
  'MESSAGE.MESSAGE_COMPOSE_CLEAR_PROVIDER_SELECTED';
export const messageComposeClearProviderSelected = () => ({
  type: MESSAGE_COMPOSE_CLEAR_PROVIDER_SELECTED
});

/**
 * Download Message Details
 */
export const DOWNLOAD_MESSAGE_DETAILS = 'MESSAGES.DOWNLOAD_MESSAGE_DETAILS';
export const DOWNLOAD_MESSAGE_DETAILS_SUCCESS = 'MESSAGES.DOWNLOAD_MESSAGE_DETAILS_SUCCESS';
export const DOWNLOAD_MESSAGE_DETAILS_FAIL = 'MESSAGES.DOWNLOAD_MESSAGE_DETAILS_FAIL';

export const downloadMessageDetails = (mhpDetails: MhpDetails, messageId: string) => async (
  dispatch: Dispatch,
  getState: () => RootState
) => {
  const state = getState();

  const originalUrl = mhpDetails.url || DispatcherEndpoint.FAIL;

  const [baseUrl, queryParams] = originalUrl.split('?');

  const appendDownloadUrl = baseUrl.replace('/id', '/id/_download');

  const url = `${appendDownloadUrl}?${queryParams}`;

  const headers = {
    ...getDownloadHeadersWithCurrentAccountConsumerId(state, url),
    [DFDHeaders.accept]: 'application/pdf',
    ...mhpDetails.headers
  };
  dispatch({ type: DOWNLOAD_MESSAGE_DETAILS, payload: { id: messageId } });

  try {
    const response = await FileServices.download(
      `message-details-${Date.now().toString()}.pdf`,
      url,
      headers
    );
    dispatch({
      type: DOWNLOAD_MESSAGE_DETAILS_SUCCESS,
      payload: { id: messageId, response }
    });
  } catch (err) {
    dispatch({
      type: DOWNLOAD_MESSAGE_DETAILS_FAIL,
      payload: { id: messageId },
      error: err
    });
  }
};
